import * as React from 'react';
import {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import {classByIntent, Intent} from '~/lib/intent';
import style from './index.module.scss';

interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    intent?: Intent;
    leftIcon?: ReactNode;
    rightIcon?: ReactNode;
    responsive?: boolean;
    to?: string;
    small?: boolean;
    iconOnly?: boolean;
    variant?: "default" | "menu";
}

export const Button = React.forwardRef<HTMLButtonElement, IButton>((props: IButton, ref) => {
    let {to, responsive, leftIcon, intent, rightIcon, small, iconOnly, variant = "default", ...otherProps} = props;
    const intentClass = variant === "menu" ? undefined : classByIntent(intent);
    let classes = [style.button, otherProps.className, intentClass];
    if (responsive) {
        classes.push(style.buttonResponsive);
    }
    if (small) {
        classes.push(style.buttonSmall);
    }
    if (iconOnly) {
        classes.push(style.buttonIconOnly);
    }
    if (variant === "menu") {
        classes.push(style.buttonMenu);
        if (intent === Intent.DANGER) {
            classes.push(style.buttonMenuDanger);
        }
    }
    let body = [];
    if (leftIcon) {
        body.push(<span key='leftIcon' className={style.buttonIcon}>{leftIcon}</span>);
    }
    if (props.children) {
        body.push(<span key='text' className={style.buttonText}>{props.children}</span>);
    }
    if (rightIcon) {
        body.push(<span key='rightIcon' className={style.buttonIcon}>{rightIcon}</span>);
    }
    return to
        ? <Link to={to} className={classes.join(' ')}>{body}</Link>
        : <button ref={ref} {...otherProps} disabled={props.disabled} className={classes.join(' ')} type={otherProps.type || 'button'}>
            {body}
        </button>;
});
